module.exports = __webpack_public_path__ + "static/media/adrian_baltariu.23f71df1.JPG";